// extracted by mini-css-extract-plugin
export default {"-large":"jf2FZpl6mK9u8zPbEADj","container":"SsDYm1g42Fl6BBh8zpqU","scrollButton":"zSI6otRHEWrRTi1MCJw2"};